import mutations from './item/mutations';
import actions from './item/actions';

const item = {
  namespaced: true,
  state: {
    item: {
      course: null,
      tag: null,
      code: null,
      days: null,
    },
    isLoading: false,
  },
  mutations,
  actions,
};

export default item;
